import http from '@/api/help'
// 登录
export const login = params => http.post('/login', params)
// 快速登录
export const quicklogin = params => http.post('/quicklogin', params)
// 客户单位登录，2026-6 追加，用来和RCN门户网站对接
export const login_for_customer = params => http.post('/login_for_customer', params)
// 退出登录
export const dropOutLogin = params => http.post('/logout', params)
// 品牌列表
export const brandlist = params => http.get('/pc/brand/list', params)
// 合同列表
export const querycontractlist = params => http.get('/contract/list', params)
// 机型列表
export const modellist = params => http.get('/pc/model/list', params)
// 用户列表
export const userlist = params => http.get('/user/list', params)
// 更改用户
export const edituser = params => http.post('/user/edit', params)
// 添加品牌
export const addbrand = params => http.post('/pc/brand/add', params)
// 添加机型
export const addmodel = params => http.post('/pc/model/add', params)
// 修改品牌
export const editbrand = params => http.post('/pc/brand/edit', params)
// 修改机型
export const editmodel = params => http.post('/pc/model/edit', params)
// 添加用户
export const adduser = params => http.post('/user/add', params)
// 合同二级菜单
export const querymenu = params => http.get('/contract', params)
// 修改合同
export const modifyContract = params => http.post('/contract/update ', params)
// 修改合同抄表日
export const modifyChaoBiaoDate = params => http.post('/contract/updateChaoBiaoDate ', params)
// 品牌下拉
export const brandSelect = params => http.get('/selection/brand', params)
// 客户单位下拉
export const customerUnit = params => http.get('/selection/company', params)
// 客户分点下拉
export const clientPoints = params => http.get('/selection/subCompany', params)
// 机型下拉
export const modelSelect = params => http.get('/selection/model', params)
// 用户下拉
export const userSelect = params => http.get('/user/selection', params)
// 维护人员下拉
export const selectionSelect = params => http.get('/selection/maintainer', params)
// 添加合同
export const addContract = params => http.post('/contract/create', params)
// 合同解约
export const delContract = params => http.post('/contract/rescission', params)
// 合同删除
export const deleteContract = params => http.post('/contract/delete', params)
// 设备列表
export const queryDeviceList = params => http.get('/device/list', params)
// 指定客户单位的设备列表（对接RCN门户网站），2026-6 追加
export const queryDeviceListForCustomer = params => http.get('/device/list_for_customer', params)
// 忘记密码
export const forgetPassword = params => http.post('/accountForgetPassword', params)
// 个人设定信息加载
export const queryPersonalSetUp = params => http.get('/user/profile', params)
// 个人设定信息修改
export const setUpPersonal = params => http.post('/user/profile', params)
// 修改密码
export const modifyPassWord = params => http.post('/user/pass', params)
// 设备二级菜单
export const queryTwoDevice = params => http.get('/device', params)
// 设备解除绑定
export const deviceUntie = params => http.post('/device/unbind', params)
// 删除运营商
export const deleteuser = params => http.post('/user/delete', params)
// 发送激活邮件
export const accountRegist = params => http.post('/accountRegist', params)
// 发送重置邮件
export const accountResetPwd = params => http.post('/accountResetPwd', params)
// 激活账号
export const accountRegistCompletion = params => http.post('/accountRegistCompletion', params)
// 重置密码
export const accountResetPassword = params => http.post('/accountResetPassword', params)
// token校验
export const getUserByToken = params => http.post('/getUserByToken', params)
// 解除抄表人员
export const unregister = params => http.post('/user/unregister', params)
// 用户停用
export const userdisable = params => http.post('/user/disable', params)
// 用户启用
export const userenable = params => http.post('/user/enable', params)
// 设备详情页柱状图
export const queryHistogramData = params => http.get('/device/counter/month', params)
// 备货状态切换
export const stockingStatusSwitch = params => http.post('/device/warn', params)
// 故障短信通知
export const SmsMalfunctionNotice = params => http.post('/device/notice', params)
// 设备详情页数据
export const queryDeviceDetails = params => http.get('/device/detail', params)
// 设备历史印量数据
export const queryHistoryData = params => http.get('/device/counter/day', params)
// 合同导出
export const exportContract = params => http.postForm('/contract/export', params)
// 合同导入
export const importContract = params => http.post('/contract/import', params)
// 导出设备
export const exportDevice = params => http.postForm('/device/export', params)
// 导出碳粉使用情况
export const exportToner = params => http.postForm('/device/exportToner', params)
// 指定月印量
export const exportDeviceCounter = params => http.postForm('/report/device/counter/month', params)
// 导出维护人员
export const exportmaintainer = params => http.postForm('/export/maintainer', params)
// 导入维护人员
export const importmaintainer = params => http.post('/import/maintainer', params)
// 导入客户分点
export const importsubCompany = params => http.post('/import/subCompany', params)
// 导入客户单位
export const importcompany = params => http.post('/import/company', params)
// 获取通知设定
export const getnotice = params => http.get('/pc/notice', params)
// 通知设定
export const putnotice = params => http.post('/pc/notice', params)
// 本地服务器列表
export const localserve = params => http.get('/pc/localServer/list', params)
// 获取用户手册名字和上传时间
export const usersManual = params => http.get('/pc/usersManual/getMsg', params)
// 删除用户手册
export const deleteusers = params => http.post('/pc/usersManual/delete', params)
// 首页调用获得验证码
export const pclogin = params => http.get('/getCode', params)
// 模板设定
export const templeteList = params => http.get('/templete/list', params)
export const templeteUsers = params => http.get('/templete/users', params)
export const templeteSearch = params => http.get('/templete/search', params)
export const templeteInfoByCategory = params => http.get(`/templete/infoByCategory`, params)
export const templeteInfoById = params => http.get(`/templete/infoById`, params)
export const templeteCreate = params => http.post('/templete/add', params)
export const templeteEdit = params => http.post('/templete/edit', params)
export const templeteDelete = params => http.post('/templete/edit', params)
// 印量统计页获得服务商列表
export const queryFacilitatorList = params => http.get('/report/facilitator', params)
// 印量统计页获得机型列表
export const queryModelList = params => http.get('/report/model', params)
